import { createAction } from '@reduxjs/toolkit';

export const clearAppSession = createAction('app/session/clear');

export const clearAppError = createAction<string | undefined>('app/error/clear');